import { JetCardPricingProps } from '@/types/jetCardPricing.types';
import styles from './jetPricing.module.scss';
import Image from 'next/image';

const JetCardPricing = ({ card }: JetCardPricingProps) => {
  return (
    <section className="container">
      <div className={styles.cardWrapper}>
        {card.map((item) => (
          <div key={item.id} className={styles.card}>
            <div className={styles.cardHeader}>
              <div
                className={styles.cardTitle}
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <div className={styles.cardImgWrapper}>
                <Image
                  src={item.img}
                  alt={item.title}
                  width={151}
                  height={45}
                  className={styles.cardImg}
                />
                <div
                  className={styles.plainName}
                  dangerouslySetInnerHTML={{ __html: item.plainName }}
                />
              </div>
            </div>

            <div className={styles.cardPriceWrapper}>
              <div className={styles.cardPriceTitle}>
                Starting at <span>{item.pricePerHour} </span>per hour
              </div>
              <div className={styles.cardPriceTitle}>
                <span>{item.price}</span> per 25 hours
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JetCardPricing;
